"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    recordsTable: {
        path: "/records/:category"
    },
    createSubmission: {
        path: "/submissions/create/:submissionTypeId/:objectId?/"
    },
    viewSubmission: {
        path: "/submissions/:submissionId"
    },
    editSubmission: {
        path: "/submissions/:submissionId/edit"
    },
    submissionSummary: {
        path: "/submissions/:submissionId/summary"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvc3VibWlzc2lvbnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICByZWNvcmRzVGFibGU6IHtcbiAgICBwYXRoOiBcIi9yZWNvcmRzLzpjYXRlZ29yeVwiLFxuICB9LFxuICBjcmVhdGVTdWJtaXNzaW9uOiB7XG4gICAgcGF0aDogXCIvc3VibWlzc2lvbnMvY3JlYXRlLzpzdWJtaXNzaW9uVHlwZUlkLzpvYmplY3RJZD8vXCIsXG4gIH0sXG4gIHZpZXdTdWJtaXNzaW9uOiB7XG4gICAgcGF0aDogXCIvc3VibWlzc2lvbnMvOnN1Ym1pc3Npb25JZFwiLFxuICB9LFxuICBlZGl0U3VibWlzc2lvbjoge1xuICAgIHBhdGg6IFwiL3N1Ym1pc3Npb25zLzpzdWJtaXNzaW9uSWQvZWRpdFwiLFxuICB9LFxuICBzdWJtaXNzaW9uU3VtbWFyeToge1xuICAgIHBhdGg6IFwiL3N1Ym1pc3Npb25zLzpzdWJtaXNzaW9uSWQvc3VtbWFyeVwiLFxuICB9LFxufSk7XG4iXSwibmFtZXMiOlsicm91dGVzIiwiYnVpbGRSb3V0ZXMiLCJyZWNvcmRzVGFibGUiLCJwYXRoIiwiY3JlYXRlU3VibWlzc2lvbiIsInZpZXdTdWJtaXNzaW9uIiwiZWRpdFN1Ym1pc3Npb24iLCJzdWJtaXNzaW9uU3VtbWFyeSJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFFYUE7OztlQUFBQTs7O3VCQUZlO0FBRXJCLE1BQU1BLFNBQVNDLElBQUFBLGtCQUFXLEVBQUM7SUFDaENDLGNBQWM7UUFDWkMsTUFBTTtJQUNSO0lBQ0FDLGtCQUFrQjtRQUNoQkQsTUFBTTtJQUNSO0lBQ0FFLGdCQUFnQjtRQUNkRixNQUFNO0lBQ1I7SUFDQUcsZ0JBQWdCO1FBQ2RILE1BQU07SUFDUjtJQUNBSSxtQkFBbUI7UUFDakJKLE1BQU07SUFDUjtBQUNGIn0=